import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Inventory from './components/Inventory'; // e.g., ./features/Inventory/InventoryPage if needed
import FactoryDashboard from './features/FactoryDashboard/FactoryDashboard';  // Updated path
import TeamLeadDashboard from './features/TeamLeadDashboard/TeamLeadDashboard';  // Updated path
import ProtectedRoute from './components/ProtectedRoute';
import { Header, Footer, Button } from './components';
import AdminCenter from './features/AdminCenter/AdminCenter';

function App() {
  return (
    <Router>
      <main style={{ padding: '20px' }}>
        <Routes>
          {/* Public route */}
          <Route path="/" element={<Login />} />
          {/* Protected routes */}
          <Route
            path="/inventory"
            element={
              <ProtectedRoute requiredRole="team_lead">
                <Inventory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/factory"
            element={
              <ProtectedRoute requiredRole="factory">
                <FactoryDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/team-lead"
            element={
              <ProtectedRoute requiredRole="team_lead">
                <TeamLeadDashboard />
              </ProtectedRoute>
            }
          />
          {/* Admin Center: accessible to users with admin or team_lead role */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="team_lead">
                <AdminCenter />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;